import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { DELETE_EVENT_RULE, DELETE_EVENT_RULE_SUCCESS, DELETE_EVENT_RULE_ERROR } from '../../../actionType';
import apiCall from '../../../apiCall';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* deleteEventRule({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/event-rules`,
      method: 'DELETE',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: DELETE_EVENT_RULE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DELETE_EVENT_RULE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DELETE_EVENT_RULE_ERROR, payload: error });
  }
}

export function* watchDeleteEventRule() {
  yield takeEvery(DELETE_EVENT_RULE, deleteEventRule);
}

function* deleteEventRuleSaga() {
  yield all([fork(watchDeleteEventRule)]);
}

export default deleteEventRuleSaga;
